export default "__VITE_ASSET__DWq2eW_4__"